import { Grid } from '@mui/material'
import MenuButton from 'components/MenuButton/MenuButton'
import { ITimeClockMenu } from './TimeClockMenus'

interface EachTimeClockMenuProps {
    onClickEachMenu: Function
    menu: ITimeClockMenu
}

const EachTimeClockMenu = ({
    onClickEachMenu,
    menu,
}: EachTimeClockMenuProps) => {
    return (
        <Grid item xs={12} sm={6}>
            <MenuButton
                onClick={() => onClickEachMenu()}
                color={menu.color}
                disabled={menu.disabled}
                icon={menu.icon}
                caption={menu.name}
            />
        </Grid>
    )
}

export default EachTimeClockMenu
